import {
	getExperience,
	getExperiencePosition,
} from '../actions/experienceActions'
import { setExperienceDetails, setUserPosition } from '../store/experienceSlice'

export const loadExperienceContext = async (
	experienceSlug,
	orgSlug,
	dispatch
) => {
	try {
		const experience = await getExperience(experienceSlug, orgSlug)
		dispatch(setExperienceDetails(experience))

		const position = await getExperiencePosition(experienceSlug, orgSlug)
		dispatch(setUserPosition(position))
	} catch (err) {
		console.error('❌ Failed to load experience context:', err)
	}
}
